import { render, staticRenderFns } from "./NewSecret.vue?vue&type=template&id=44757e54&"
import script from "./NewSecret.vue?vue&type=script&lang=js&"
export * from "./NewSecret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports